/**
 * mc-media-grouping.js — Multi-option media grouping enhancement
 * Erweitert die Enterprise Theme MediaGallery um Multi-Option-Filterung.
 * Wird nur geladen wenn groupOptions.length > 1 (via Liquid-Bedingung).
 * 
 * Funktionsweise:
 * - Liest groupOptions aus dem JSON-Datenblock
 * - Überschreibt getMediaGroupFromOptionSelectors() um composite keys zu lesen
 *   (z.B. "Cat6 Rund | Schwarz" statt nur "Cat6 Rund")
 * - Reset + Re-Init der Gruppenlogik mit composite keys
 */
(function() {
  'use strict';

  function enhanceGalleries() {
    var galleries = document.querySelectorAll('media-gallery[data-media-grouping-enabled]');
    
    galleries.forEach(function(gallery) {
      var data = gallery.getMediaGroupData && gallery.getMediaGroupData();
      if (!data || !data.groupOptions || data.groupOptions.length <= 1) return;

      // Override: Lese ALLE grouping-Optionen und baue composite key
      gallery.getMediaGroupFromOptionSelectors = function() {
        var optionSelectors = this.section.querySelectorAll('.option-selector');
        var keys = [];
        
        for (var i = 0; i < data.groupOptions.length; i++) {
          var gopt = data.groupOptions[i];
          if (gopt.index < optionSelectors.length) {
            var selector = optionSelectors[gopt.index];
            var val;
            if (selector.dataset.selectorType === 'dropdown') {
              val = selector.querySelector('.custom-select__btn').textContent.trim();
            } else {
              var checked = selector.querySelector('input:checked');
              val = checked ? checked.value : '';
            }
            keys.push(val);
          }
        }
        
        return keys.join(' | ');
      };

      // mc-patch 16.09. (CG-Control): Bloecke je Varianten-Schluessel. Varianten, die
      // dasselbe Vorschaubild teilen (Groesse S/M), teilen den Block (Alias); ein
      // Schluessel ohne eigenen Block nimmt den naechstpassenden Block statt ALLER
      // Bilder (Fund Joyroom JR-TF4 / Staubsauger-Zubehoer).
      gallery.getMediaGroupMap = function() {
        if (this.mediaGroupMap) return this.mediaGroupMap;
        var vm = data.variantMedia || [];
        var byMedia = {};
        for (var k = 0; k < vm.length; k++) {
          var mid = vm[k].mediaId;
          if (!byMedia[mid]) byMedia[mid] = [];
          if (byMedia[mid].indexOf(vm[k].option) < 0) byMedia[mid].push(vm[k].option);
        }
        var map = { groups: {} };
        var current = null;
        var thumbs = this.thumbs;
        this.viewerItems = this.querySelectorAll('.media-viewer__item');
        this.viewerItems.forEach(function(item) {
          var keys = byMedia[parseInt(item.dataset.mediaId, 10)];
          if (keys && keys.length) {
            var block = null;
            for (var j = 0; j < keys.length; j++) {
              if (map.groups[keys[j]]) { block = map.groups[keys[j]]; break; }
            }
            if (!block) block = { name: keys[0], items: [] };
            for (var j2 = 0; j2 < keys.length; j2++) { map.groups[keys[j2]] = block; }
            current = block;
          }
          if (current) {
            var gi = { main: item };
            if (thumbs) {
              gi.thumb = thumbs.querySelector('[data-media-id="' + item.dataset.mediaId + '"].media-thumbs__item');
            }
            current.items.push(gi);
          }
        });
        map.groupFromItem = function(item) {
          var names = Object.keys(map.groups);
          for (var a = 0; a < names.length; a++) {
            var g = map.groups[names[a]];
            for (var b = 0; b < g.items.length; b++) { if (g.items[b].main === item) return g; }
          }
          return map.groups[names[0]];
        };
        this.mediaGroupMap = map;
        return map;
      };

      var mcSchluessel = gallery.getMediaGroupFromOptionSelectors;
      gallery.getMediaGroupFromOptionSelectors = function() {
        var full = mcSchluessel.call(this);
        var groups = this.getMediaGroupMap().groups;
        if (!full || groups[full]) return full;
        var keys = full.split(' | ');
        var best = null, bestN = 0;
        for (var name in groups) {
          if (!Object.prototype.hasOwnProperty.call(groups, name)) continue;
          var parts = name.split(' | ');
          var n = 0;
          for (var q = 0; q < keys.length; q++) { if (parts[q] === keys[q]) n++; }
          if (n > bestN) { bestN = n; best = name; }
        }
        return best || full;
      };

      // Reset cached group map to force rebuild with composite keys
      gallery.mediaGroupMap = null;

      // Re-initialize grouping with composite key
      if (!gallery.noSelectedVariant) {
        gallery.setActiveMediaGroup(gallery.getMediaGroupFromOptionSelectors());
      }
    });
  }

  // Timing: media-gallery.js (defer) runs first, elements get upgraded.
  // This script (defer, loaded after) runs next. Galleries are initialized.
  // Small delay for safety (Shopify Design Mode uses setTimeout 200ms).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(enhanceGalleries, 50);
    });
  } else {
    setTimeout(enhanceGalleries, 50);
  }
})();
